export const timberData = [
  { 
    "name": "台灣肖楠",
    "speciesName": "Calocedrus formosana",
    "cf": 0.262,
  },
  { 
    "name": "紅檜",
    "SpeciesName": "Chamaecyparis formosensis",
    "cf": 0.204,
  },
  { 
    "name": "台灣扁柏",
    "speciesName": "Cryptomeria obtusa",
    "cf": 0.203,
  },
  { 
    "name": "柳杉",
    "speciesName": "Cryptomeria japonica",
    "cf": 0.177,
  },
  {
    "name": "福州杉",
    "speciesName": "Cunninghamia lanceolata",
    "cf": 0.150,
  },
  {
    "name": "台灣雲杉",
    "speciesName": "Picea morrisonicola",
    "cf": 0.221,
  },
  {
    "name": "台灣二葉松",
    "speciesName": "Pinus taiwanensis",
    "cf": 0.259,
  },
  {
    "name": "台灣雲杉",
    "speciesName": "Picea morrisonicola",
    "cf": 0.221,
  },
  {
    "name": "台灣杉",
    "speciesName": "Tawania cryptomerioides",
    "cf": 0.155,
  },
  {
    "name": "台灣鐵杉",
    "speciesName": "Tsuga chinensis",
    "cf": 0.205,
  },
  {
    "name": "相思樹",
    "speciesName": "Picea morrisonicola",
    "cf": 0.221,
  },
  {
    "name": "台灣雲杉",
    "speciesName": "Acacia confusa",
    "cf": 0.363,
  },
  {
    "name": "台灣赤楊",
    "speciesName": "Alnus japonica",
    "cf": 0.217,
  },
  {
    "name": "茄冬",
    "speciesName": "Bischofia javanica",
    "cf": 0.304,
  },
  {
    "name": "木麻黃",
    "speciesName": "Casuarina equisetifolia",
    "cf": 0.312,
  },
  {
    "name": "樟木",
    "speciesName": "Cinnamomum camphora",
    "cf": 0.174,
  },
  {
    "name": "牛樟",
    "speciesName": "Cinnamomum micranthum",
    "cf": 0.178,
  },
  {
    "name": "光蠟樹",
    "speciesName": "Fraxinus formosana",
    "cf": 0.342,
  },
  {
    "name": "大葉楠",
    "speciesName": "Machilus kusanoi",
    "cf": 0.218,
  },
  {
    "name": "香楠",
    "speciesName": "Machilus zuihoensis",
    "cf": 0.221,
  },
  {
    "name": "楝樹",
    "speciesName": "Melia azedarach",
    "cf": 0.252,
  },
  {
    "name": "烏心石",
    "speciesName": "Michelia compressa",
    "cf": 0.247,
  },
  {
    "name": "印度紫檀",
    "speciesName": "Pterocarpus indicus",
    "cf": 0.273,
  },
  {
    "name": "木荷",
    "speciesName": "Schima superba",
    "cf": 0.286,
  },
  {
    "name": "大葉桃花心木",
    "speciesName": "Swietenia macrophylla",
    "cf": 0.236,
  },
  {
    "name": "台灣櫸",
    "speciesName": "Zelkova serrata",
    "cf": 0.348,
  },
]